// @flow

import type { PagesState } from "./types";

export const pagesInitialState: PagesState = {
  requestsInProgress: 0,
  eventsPage: {
    alertsCount: null,
    rtwInterviewsCount: null,
    absenceMonitoringCount: null,
    wellbeingReferralsCount: null,
  },
  classificationsPage: {
    absenceReasonsCount: null,
    staffGroupsCount: null,
    shiftPatternsCount: null,
    nurseDeclinedCount: null,
  },
  promptsPage: {
    dynamicQuestionsCount: null,
    standardQuestionsCount: null,
    departmentScriptsCount: null,
    reasonScriptsCount: null,
  },
};
